import React from 'react';

type ButtonVariant = 'flat' | 'outline' | 'text';
type ButtonColor = 'primary' | 'gradient' | null;

interface ReusableButtonProps {
  className?: string;
  onClick?: () => void;
  children: React.ReactNode;
  variant?: ButtonVariant;
  color?: ButtonColor;
}

const ReusableButton: React.FC<ReusableButtonProps> = ({
  className = '',
  onClick,
  children,
  variant = 'flat',
  color = 'primary',
}) => {
  // Get button styles based on variant and color
  const getButtonStyles = () => {
    // Gradient color (subtle white-to-indigo gradient)
    if (color === 'gradient') {
      if (variant === 'flat') {
        return 'bg-gradient-to-r from-indigo-300 to-indigo-600 text-white border-transparent hover:from-indigo-400 hover:to-indigo-700 hover:shadow-lg transition-all duration-200';
      }
      if (variant === 'outline') {
        return 'bg-transparent text-indigo-600 border-indigo-600 hover:bg-gradient-to-r hover:from-indigo-300 hover:to-indigo-600 hover:text-white transition-all duration-200';
      }
      if (variant === 'text') {
        return 'bg-transparent text-indigo-600 border-transparent hover:bg-indigo-50 transition-all duration-200';
      }
    }

    // Default primary color (original blue)
    return 'bg-[rgb(87,115,255)] text-white border-[rgba(255,255,255,0.1)] hover:bg-[rgb(67,95,235)]';
  };

  return (
    <button
      className={`flex
        items-center
        cursor-pointer
        gap-2
        box-border
        text-[14px]
        rounded-[28px]
        border
        py-[9px]
        px-[16px]
        transition-all
        duration-200
        ${getButtonStyles()}
        ${className}`}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default ReusableButton;
